/*global jQuery:false */
/*global detectFeatures:false */
/*global _:false */
// we call detectfeatures to add awesome class to <html> (.server-dev .server-qa .server-int ...)

Revealizr.detectFeatures();

//Use to detect language on any page
if ($('html').attr('lang')) {
    var lang_generic = $('html').attr('lang').split('-');
    var lang = lang_generic[0];
}

var resizeTimer;
$(window).on('resize', function(e) {
    Revealizr.detectFeatures();
    clearTimeout(resizeTimer);
});

/*Smooth Scroll*/
/* https://css-tricks.com/snippets/jquery/smooth-scrolling/ */
$(function() {
  $('.backToTop-link a').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: 0
        }, 1000);
        return false;
      }
    }
  });
});

// Global var
let linkInternalPositionModifier = '';

jQuery(document).ready(function () {
	'use strict';

	closedForSession();

    // lightbox
    jQuery(".fancybox").fancybox({
        beforeLoad: function () {
            var el, id = $(this.element).data('fancybox');

            if (id) {
                el = $('#' + id);

                if (el.length) {
                    this.title = el.html();
                }
            }
        }
    });

    //Open a new target for links beginning with http/https
    jQuery('a[href^="http://"]').click(function () {
        if (this.rel != 'internal') {
            this.target = '_blank';
        }
    });

    jQuery('a[href^="http://"]').click(function () {
        if (this.rel != 'internal') {
            this.target = '_blank';
        }
    });

    // We disable link with class .disabled
    $("a.disabled").on("click", function (event) {
        event.preventDefault();
    });

    initFormMasks();

    // Tabs default
    $('[data-feature="tabs--default"]').tabs_default();

	// Carousel : 5 images en desktop
	$('[data-module~="carousel-image"]').carousel_slick({
		dots: false
	});

	carouselSlick();
    pdpCarouselSlick();
    productTileSlick();
    productTileSlickPlusBanner();
    flyerTileSlick();
    accountOverviewDiscountCouponsSlick();
    upassTilesSlick();
    upassProductTilesSlick();
    displayAndroidAppBanner();
    displayScrollTop();

    if( Revealizr.isMobileSize ) {
		linkInternalPositionModifier = '.header-primary, #headerSearchForm';
	} else {
		linkInternalPositionModifier = '.header-primary';
	}

	// Link internal onload
	if( document.querySelector( '#container.vitrine' ) !== null ) {
		$(window).link_internal({
			positionModifier: linkInternalPositionModifier,
			positionModifierMultiplier: 2
		});
	}

	// Link internal
	$('#container.vitrine [data-module~="link-internal"] ').link_internal({
		positionModifier: linkInternalPositionModifier,
		positionModifierMultiplier: 2
	});

	$('#container.template-checkout [data-module~="link-internal"] ').link_internal({
		positionModifier: 20
	});

	$('[data-module~="back-top"] ').backTop();

	// Display or hide the checkout's carousel
	$('.order-summary-wrapper .osw__display-list, .order-summary-wrapper .osw__hide-list').on('click.order-list-display', function(){
		var order_summary_wrapper = $(this).closest('.order-summary-wrapper');
		order_summary_wrapper.find( '.osw__display-preview' ).click();
	});

	// Wait 200ms. Waiting that all JS affecting layout are done.
	setTimeout(function(){
		$('[data-module~="stickyState"]').stickyState();
	}, 200);

    $('[data-input-clear=""]').click( function () {
        manageEraseButton();
    });

    externalLinkAssist();
    LoginEvents.lookup();

    $('.btnChangeLang').on('click', function () {
        window.location.href = $('.js-change-my-language').attr('href');
    });

    let $searchCloseBtn = $('.search__overlay .input-close');

    $searchCloseBtn.on('click', function() {
        $('.search__overlay #header--search--input').val('');
    });
});

function initAnimation() {
    if (typeof lottie === 'undefined'){
        return;
    }

    $('[data-animation-src]').not('.isAnimated').each(function() {
        lottie.loadAnimation({
            container: this,
            path: $(this).attr('data-animation-src'),
            renderer: 'svg',
            loop: true,
            autoplay: true
        });
        this.classList.add('isAnimated');
    });
}

function ScrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

function initFormMasks() {
    // Input tel mask injection
    initTelMask();

    initPostalCodeMask();

    $('[type="number"][max="9"]').mask('0');
    $('[type="number"][max="999"]').mask('000');
    $('[type="number"][max="9999"]').mask('0000');
    $('[type="number"][max="99999"]').mask('00000');
    $('[type="number"][max="999999999"]').mask('000000000');

    // Input maxlength mask injection (android bug fallback)
    $('.android .mmc--form-input1, .android .mmc--form-input2, .android .mmc--form-input3').each(function __maxlengthMask(){
        var maskpattern = "";
        for (var i = this.maxLength - 1; i >= 0; i--) {
            maskpattern += "0";
        }

        $(this).mask(maskpattern);
    });

    // Must be on all pages
    $('input[type=search]').keyup( function () {
        manageSearchButtonWithEraseButton($(this));
    });
}

function initPostalCodeMask(containerPostalCode, selectorPostalCode) {
    const postalCodeInputsSelectors = 'input[name$=postalCode],input[name$=deliveryPostalCode],input[name$=addressPostalCode],input[name$=cardAddressPostalCode],input[name$=confirmationPostalCode]';
    var $postalCodes;
    if (selectorPostalCode !== undefined) {
        $postalCodes = containerPostalCode ? $(selectorPostalCode, containerPostalCode) : $(selectorPostalCode);
    } else {
        $postalCodes = containerPostalCode ? $(postalCodeInputsSelectors, containerPostalCode) : $(postalCodeInputsSelectors);
    }
    $postalCodes.mask('S0S 0S0');
}

function initTelMask(containerTel) {
    var $tels = containerTel ? $('input[type=tel]', containerTel) : $('input[type=tel]');
    $tels.mask('000-000-0000');
}

function manageSearchButtonWithEraseButton($inputSearch) {
    var $parentForm = $('#headerSearchForm');
    var $buttonClose = $parentForm.find('.input-close');
    if ($buttonClose.length) {
        if ($inputSearch.val() !== '') {
            $buttonClose.removeClass('field_is_empty');
        } else {
            $buttonClose.addClass('field_is_empty');
        }
    }
}

function manageEraseButton() {
    var parentForm = $('#headerSearchForm');
    $(parentForm).find('input[type=search]').val('');
    $(parentForm).find('.input-close').addClass('field_is_empty');
    $('.search__overlay').hide().removeClass('d-flex');
    emptyAndHideAutocompleteResults($('#header-search-autocomplete-result'));
}

//Reload an image by its id
function reloadImg(id) {
    'use strict';
    var obj = document.getElementById(id);
    var src = obj.src;
    var pos = src.indexOf('?');
    if (pos >= 0) {
        src = src.substr(0, pos);
    }
    var date = new Date();
    obj.src = src + '?v=' + date.getTime();
    return false;
}

function displayAndroidAppBanner () {
    const appBanner =  document.getElementById('androidAppBanner');
    if (TINK.getCookie('androidAppBannerActive') !== 'false' && appBanner != null) {
        smartAppBanner.displayAppBanner(appBanner);
    }
}

function displayScrollTop () {
    window.addEventListener('scroll', function() {
        let appBannerVisible = $('.app-android-banner').not('.hide').length > 0;
        let couponStickyVisible = $('.sticky-clip-all-coupons').length > 0;
        let bottomPos;
        // Check if the scroll position is more than 2 viewport heights
        if (window.scrollY > 2 * window.innerHeight) {
            $('#scrollButton').removeClass('hide');
            if (appBannerVisible && couponStickyVisible) {
                isInWebview() ? bottomPos = '18rem' : bottomPos = '24rem';
            } else if (appBannerVisible || couponStickyVisible)  {
                isInWebview() ? bottomPos = '9rem' : bottomPos = '15rem';
            } else {
                isInWebview() ? bottomPos = '2rem' : bottomPos = '8rem';
            }
            $('#scrollButton').css('bottom', bottomPos);
        } else {
            $('#scrollButton').addClass('hide');
        }
    });
}

//Debug anchor For iPhone
document.addEventListener("DOMContentLoaded", () => {
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const hash = window.location.hash.slice(1);
    const element = document.getElementById(hash);

    if (isiOS && element) {
        element.scrollIntoView();
    }
});